import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/mileage-reimbursement-calculator',
  component: () => import('../../routes/MileageReimbursementCalculator.svelte'),
  card: {
    id: 'mileage-reimbursement-calculator',
    title: 'Mileage Reimbursement Calculator',
    description: 'Calculate your mileage reimbursement based on the IRS standard mileage rate. Supports business, medical, and charitable mileage.',
    icon: 'directions_car',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/mileage-reimbursement-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Mileage Reimbursement Calculator – IRS Standard Mileage Rate Calculator',
    description:
      'Free mileage reimbursement calculator using the IRS standard mileage rate. Calculate your business mileage deductions and reimbursement amounts for 2025-2026.',
  },
};

export default meta;
